import orderBy from 'lodash/orderBy';

export function orderByPosition<T>(items: any): T[] {
    return orderBy(items || [], (item) => item.position, 'asc') as any;
}
